export default __webpack_public_path__ + "static/media/slide1.68a76ea7.jpg";